import { cn } from "@v1/ui/utils";
import { MessageCircle } from "lucide-react";
import type { ReactElement } from "react";

/** Chat bubble glyph: org's own icon drawn white, else the speech bubble. */
export function ChatLauncherIcon({
  iconUrl,
  className,
}: {
  readonly iconUrl: string | null;
  readonly className?: string;
}): ReactElement {
  if (iconUrl === null) {
    return <MessageCircle className={className} strokeWidth={2} aria-hidden />;
  }
  return (
    // eslint-disable-next-line @next/next/no-img-element -- org icon from S3 proxy
    <img
      src={iconUrl}
      alt=""
      aria-hidden
      // Upload stores a white glyph already; filter keeps older uploads white too.
      className={cn("object-contain brightness-0 invert", className)}
    />
  );
}
